import React from "react";
import { Text, Pressable, StyleSheet } from "react-native";

import global from "../../../styles/globalStyles";
import { supabase } from "../../../utils/supabase";
import { clientDomain } from "../../../config";
import { mixpanel } from "../../../utils/mixpanel";

import { Apple, Google } from "../../../assets/index";

type LoginWithGoogleButtonProps = {
  name: string;
  redirectTo?: string;
  trackSignupStarted?: boolean;
  provider?: "google" | "apple";
};

const normalizeRedirectPath = (redirectPath: string) => {
  return redirectPath.startsWith("/") ? redirectPath : `/${redirectPath}`;
};

const LoginWithGoogleButton: React.FC<LoginWithGoogleButtonProps> = ({
  name,
  redirectTo = "/home",
  trackSignupStarted = false,
  provider = "google",
}) => {
  const handleLoginWithOAuth = async () => {
    const normalizedRedirectPath = normalizeRedirectPath(redirectTo);
    const options = {
      redirectTo: new URL(normalizedRedirectPath, clientDomain).toString(),
    };
    if (trackSignupStarted) {
      mixpanel.track("Signup Started", {
        "Signup Method": provider === "apple" ? "Apple OAuth" : "Google OAuth",
      });
    }

    supabase.auth.signInWithOAuth({
      provider,
      options,
    });
  };

  return (
    <Pressable style={styles.container} onPress={handleLoginWithOAuth}>
      {provider === "apple" ? <Apple size={24} /> : <Google size={24} />}
      <Text style={[global.text, global.fontSize16, global.fontWeight500]}>
        {name}
      </Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    paddingHorizontal: 24,
    paddingVertical: 12,
    gap: 12,
    backgroundColor: "#fff",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#282B33",
  },
  image: {
    width: 24,
    height: 24,
  },
});

export default LoginWithGoogleButton;
